import React from "react";
import { connect } from "react-redux";
import {
    quizSelector,
    setQuizData,
    setPreviousQuestion,
    goToStep,
    setRev,
} from "redux/reducers/quiz-reducer";
import { questionsMap } from "../questionTypes/questionsMap.js";
import webservice from "../../API/webservice.js";
import { classesLogic } from "../utils/utils.js";
import { convertStrToLink } from "../utils/utils.js";
import { validateForm } from "../validation/validateForm.js";
import { validateCheckbox } from "../validation/validateCheckbox.js";
import { validateLength } from "../validation/validateLength.js";
import { invokeTimerPopup, removeTimerPopup } from "../../spinner/wizardSpinnerFlow.js";

class WizardToolQuestionWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentAnswer: null,
            currentAnswerError: false,
            checkboxChecked: false,
            checkboxCheckedError: false,
            showCheckboxModal: false,
            isLoading: false,
            isLoadingSecondary: false,
            mountState: 0,
        };

        this.validateItem = this.validateItem.bind(this);
        this.resetCurrentAnswerError = this.resetCurrentAnswerError.bind(this);
        this.submitItem = this.submitItem.bind(this);
        this.submitItemSecondary = this.submitItemSecondary.bind(this);
        this.submitAnswer = this.submitAnswer.bind(this);
        this.openModal = this.openModal.bind(this);
        this.scrollToBtn = this.scrollToBtn.bind(this);
        this.toggleCheckbox = this.toggleCheckbox.bind(this);
        this.setCookieToolStart = this.setCookieToolStart.bind(this);
        this.trackForm = this.trackForm.bind(this);
    }

    componentWillReceiveProps(prevProps, prevState) {
        if (this.state.currentAnswer !== this.props.data.Answer) {
            this.setState({
                currentAnswer: this.props.data.Answer,
            });
        }
    }

    resetCurrentAnswerError() {
        this.setState({ currentAnswerError: false });
    }

    setCookieToolStart(id) {
        if (shvenergy.cookies.hasCookieCategoryConsent("_shvenergy_wizard_incomplete")) {
            shvenergy.cookies.setCookie("_shvenergy_wizard_incomplete", id, 90);
        }
    }

    validateItem(e) {
        // This is a lightweight validation before submit.
        // It basically checks if the answer has a value and either turns on the alert message under the form element or call submitItem function
        // Actual validation is in the question components and serverside

        e.preventDefault();

        if (!this.state.isLoading && !this.state.isLoadingSecondary) {
            let item = this.props.data;
            let qIsValid = false;
            let checkboxValid = true;

            if (item.ItemType === "Form") {
                // Complex answer with multiple inputs
                qIsValid = validateForm(this.props, this.state);
            } 
            else if(item.ItemType === "InformationMessage"){
                qIsValid = true;
            }
            else {
                // Simple answer with string structure
                qIsValid = validateLength(this.state.currentAnswer);
            }

            if (item.Checkbox) {
                // Validate the checkbox
                checkboxValid = validateCheckbox(this.state.checkboxChecked, item);
            }

            //Ready to submit?
            this.setState({
                currentAnswerError: !qIsValid,
                checkboxCheckedError: !checkboxValid,
            });

            if (qIsValid && checkboxValid) {
                this.submitItem(this.state.currentAnswer);
                this.trackAnswer(item);
            }
        }
    }

    validateItemNoButton(id) {
        // This is a lightweight validation before submit.
        // It basically checks if the answer has a value and either turns on the alert message under the form element or call submitItem function
        // Actual validation is in the question components and serverside

        if (!this.state.isLoading && !this.state.isLoadingSecondary) {
            let item = this.props.data;
            let qIsValid = false;
            let checkboxValid = true;

            qIsValid = validateLength(id);

            if (item.Checkbox) {
                // Validate the checkbox
                checkboxValid = validateCheckbox(this.state.checkboxChecked, item);
            }

            if(item.ItemType === "InformationMessage"){
                qIsValid = true;
            }

            //Ready to submit?
            this.setState({
                currentAnswer: id,
                currentAnswerError: !qIsValid,
                checkboxCheckedError: !checkboxValid,
            });

            if (qIsValid && checkboxValid) {
                this.submitItem(id);
                this.trackAnswer(item, id);
            }
        }
    }

    trackAnswer(item, id) {
        if (['Calendar', 'DropdownList', 'MultipleIcons', 'MultipleImages', 'NumberedBoxes', 'NumberInputMultipleOptions',
            'NumberInputSingleOption', 'RadioButtons', 'SingleIcon', 'SingleImage', 'Slider'].indexOf(item.ItemType) !== -1) {
            let answer;
            
            if (['DropdownList', 'RadioButtons', 'SingleIcon', 'SingleImage'].indexOf(item.ItemType) !== -1) {
                item.Options.forEach(option => {
                    if (option.Id === (id ? id : this.state.currentAnswer)) {
                        answer = option.Header;
                        return;
                    }
                });
            }

            if (['NumberedBoxes', 'Slider'].indexOf(item.ItemType) !== -1) {
                answer = item.Answer;
            }

            if (['NumberInputMultipleOptions', 'NumberInputSingleOption'].indexOf(item.ItemType) !== -1) {
                answer = item.Answer.Value;
            }

            if (['MultipleIcons', 'MultipleImages'].indexOf(item.ItemType) !== -1) {
                answer = "";
                item.Options.forEach(option => {
                    if (item.Answer.indexOf(option.Id) !== -1) {
                        answer = `${answer}${option.Header}|`;
                    }
                });
                answer = answer.substring(0, answer.length - 1);
            }

            if (item.ItemType === 'Calendar') {
                answer = "";
                item.Answer.forEach(userAnswer => {
                    answer = `${answer}${userAnswer}|`;
                });
                answer = answer.substring(0, answer.length - 1);
            }

            shvenergy.tracking.trackRawEventData({
                event: 'clickWizardTool',
                userResponse: answer,
                question: item.Header,
                step: this.props.currentStep,
                typeWizard: this.props.quizSettings.Name
            });
        }
    }

    trackForm() {
        const {
            data: {
                ItemType = '',
                Fields = []
            } = {},
        } = this.props;

        if (ItemType !== 'Form') return;

        const hiddenFields = Fields.filter(field => field.ItemType === 'HiddenField');

        const formName = hiddenFields.find(field => field.HiddenFieldName === 'formName');
        const typeForm = hiddenFields.find(field => field.HiddenFieldName = 'typeForm');

        const formNameValue = formName ? formName.HiddenFieldValue : '';
        const typeFormValue = typeForm ? typeForm.HiddenFieldValue : '';

        shvenergy.tracking.trackRawEventData({
           event: 'submitForm',
           formName: formNameValue,
           typeForm: typeFormValue,
        });
    }

    submitItem(id) {
        let timeOut;
        let SpinnerMessages;
        let SpinnerBGColor;
        let SpinnerMessageIntervals;
        if (this.props.remainingValue === 1 && this.props.SpinnerEnable) {
            SpinnerMessages = this.props.SpinnerMessages
            SpinnerBGColor = this.props.SpinnerBGColor;
            SpinnerMessageIntervals = this.props.SpinnerMessageIntervals;

            if (!SpinnerMessageIntervals) {
                SpinnerMessageIntervals = 10;
            }
            timeOut = setTimeout(function () {
                invokeTimerPopup(SpinnerMessages, SpinnerBGColor, SpinnerMessageIntervals);
            }, SpinnerMessageIntervals * 1000);
        }
        if (!this.state.isLoading && !this.state.isLoadingSecondary) {
            var that = this;
            let qs = this.props.quizSettings;
            let item = this.props.data;
            let newQuizSettings = Object.assign({}, qs);
            newQuizSettings.Items[this.props.currentStep].Answer = id;
            newQuizSettings.Items.splice(
                this.props.currentStep + 1,
                newQuizSettings.Items.length
            );

            if (newQuizSettings.Items[this.props.currentStep].Checkbox) {
                newQuizSettings.Items[
                    this.props.currentStep
                ].Checkbox.IsCheckBoxChecked = this.state.checkboxChecked;
            }

            this.setState({ isLoading: true });

            if (this.props.currentStep === 0) {
                //Set cookie when first question is answered
                this.setCookieToolStart(qs.Id);
            }

            let data = webservice.submitQuizData(newQuizSettings);

            data
                .then((response) => {
                    this.props.setPreviousQuestion(this.props.currentStep);
                    let newData = response.data;
                    this.props.setQuizData(newData);
                    this.props.goToStep(this.props.currentStep + 1);
                    this.setState({ isLoading: false });
                    shvenergy.tracking.trackEvent(
                        "wizardTool",
                        "nextClicked",
                        item.Header
                    );
                    this.trackForm();
                    setTimeout(function () {
                        $(".wizard-tool__wrapper").animate({ scrollTop: 0 }, 200);
                    }, 500);
                    
                    if (this.props.remainingValue === 0 && this.props.SpinnerEnable) {
                        clearTimeout(timeOut);
                        removeTimerPopup();
                    }
                })
                .catch(function (error, response) {
                    if (error.response.status !== 200) {
                        if (qs.ErrorPageUrl) {
                            window.location.href = qs.ErrorPageUrl;
                        } else {
                            setTimeout(function () {
                                that.setState({ isLoading: false });
                            }, 1000);
                        }
                        clearTimeout(timeOut);
                        removeTimerPopup();
                    }
                });
        }
    }

    submitItemSecondary() {
        if (!this.state.isLoading && !this.state.isLoadingSecondary) {
            var that = this;
            let qs = this.props.quizSettings;
            let item = this.props.data;
            let newQuizSettings = Object.assign({}, qs);

            newQuizSettings.Items[this.props.currentStep].IsQuestionSkipped = true;
            newQuizSettings.Items.splice(
                this.props.currentStep + 1,
                newQuizSettings.Items.length
            );

            this.setState({ isLoadingSecondary: true });

            if (this.props.currentStep === 0) {
                //Set cookie when first question is skipped
                this.setCookieToolStart(qs.Id);
            }

            let data = webservice.submitQuizDataSecondary(newQuizSettings);

            data
                .then((response) => {
                    this.props.setPreviousQuestion(this.props.currentStep);
                    let newData = response.data;
                    this.props.setQuizData(newData);
                    this.props.goToStep(this.props.currentStep + 1);
                    this.setState({ isLoadingSecondary: false });
                    shvenergy.tracking.trackEvent(
                        "wizardTool",
                        "skipQuestionClicked",
                        item.Header
                    );
                    setTimeout(function () {
                        $(".wizard-tool__wrapper").animate({ scrollTop: 0 }, 200);
                    }, 500);
                })
                .catch(function (error, response) {
                    if (error.response.status !== 200) {
                        if (qs.ErrorPageUrl) {
                            window.location.href = qs.ErrorPageUrl;
                        } else {
                            setTimeout(function () {
                                that.setState({ isLoadingSecondary: false });
                            }, 1000);
                        }
                    }
                });
        }
    }

    submitAnswer(id) {
        if (
            (this.props.data.ItemType === "SingleIcon" ||
                this.props.data.ItemType === "SingleImage") &&
            !this.props.data.Buttons.HideButtonsBelowQuestion
        ) {
            this.scrollToBtn();
        }
        if (!this.props.data.Buttons.HideButtonsBelowQuestion) {
            this.setState({ currentAnswer: id, currentAnswerError: false });
        } else {
            this.validateItemNoButton(id);
        }
    }

    scrollToBtn() {
        if (this.props.currentStep > 0) {
            const buttonOffset =
                this.refs.submitBtn.offsetTop +
                $(this.refs.submitBtn).closest(".step")[0].offsetTop;
            const containerHeight = $(".wizard-tool__wrapper")[0].offsetHeight;
            const containerScroll = $(".wizard-tool__wrapper").scrollTop();
            if (containerHeight + containerScroll - 40 < buttonOffset) {
                const amountToScroll =
                    buttonOffset -
                    containerHeight +
                    $(this.refs.submitBtn).outerHeight() +
                    10;
                $(".wizard-tool__wrapper").animate({ scrollTop: amountToScroll }, 800);
            }
        } else {
            var butt = $(this.refs.submitBtn);

            var top_of_element = butt.offset().top;
            var bottom_of_element = butt.offset().top + butt.outerHeight();
            var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
            var top_of_screen = $(window).scrollTop();

            if (
                bottom_of_screen > top_of_element &&
                top_of_screen < bottom_of_element
            ) {
                // console.log("The button is already in the viewport, don't do anything");
            } else {
                let scrollTo = $(this.refs.submitBtn).offset().top - window.innerHeight;

                if (document.getElementById("anchor-menu")) {
                    if (scrollTo > 100) scrollTo -= 100;
                }
                $("html, body").animate({ scrollTop: scrollTo + 60 }, 800);
            }
        }
    }

    openModal(e, modalContent) {
        if (e.nativeEvent.target.className === "open-modal") {
            e.preventDefault();
            e.stopPropagation();
            shvenergy.modal.showModal(modalContent);
        }
    }

    toggleCheckbox(e) {
        if (e.target.checked) {
            this.setState({
                checkboxChecked: e.target.checked,
                checkboxCheckedError: false,
            });
        } else {
            this.setState({ checkboxChecked: e.target.checked });
        }
    }

    render() {
        let currentStep = this.props.currentStep;
        let previousQuestion = this.props.previousQuestion;
        let item = this.props.data;
        let checkboxTextArr = null;
        let aboveCheckboxTextArr = null;
        let belowButtonTextArr = null;
        let CurrentQuestion = questionsMap[item.ItemType]
            ? questionsMap[item.ItemType]
            : null;
        const classNames = classesLogic(
            this.props.index,
            currentStep,
            previousQuestion
        );

        if (item.Checkbox) {
            checkboxTextArr = convertStrToLink(
                item.Checkbox.CheckboxText,
                this.props.data.Checkbox.CheckboxPopupTextTrackingId
            );
        }

        if (item.TextWithPopups) {
            if (item.TextWithPopups.TextWithPopupAboveCheckbox.Text) {
                aboveCheckboxTextArr = convertStrToLink(
                    item.TextWithPopups.TextWithPopupAboveCheckbox.Text,
                    "#123456789"
                );
            }

            if (item.TextWithPopups.TextWithPopupBelowButtons.Text) {
                belowButtonTextArr = convertStrToLink(
                    item.TextWithPopups.TextWithPopupBelowButtons.Text,
                    "#987654321"
                );
            }
        }

        let showOverlaySpinner = false;
        if (item.Buttons) {
            showOverlaySpinner =
                item.Buttons.HideButtonsBelowQuestion && this.state.isLoading
                    ? true
                    : false;
        }

        return (
            <div className={classNames.join(" ")}>
                {item.ItemType !== "DeadEndMessage" && <h2>{item.Header}</h2>}
                {item.ItemType !== "DeadEndMessage" && item.HelpText && (
                    <div className="subheader">{item.HelpText}</div>
                )}
                

                {CurrentQuestion && (
                    <CurrentQuestion
                        data={item}
                        submitAnswer={(id) => this.submitAnswer(id)}
                        mapsAPIloaded={this.props.mapsAPIloaded}
                        GoogleMapSettings={this.props.quizSettings.GoogleMapSettings}
                        validate={this.state.validate}
                        currentAnswerError={this.state.currentAnswerError}
                        currentAnswer={this.props.currentAnswer}
                        goToStep={(step) => this.props.goToStep(step)}
                        setPreviousQuestion={(step) => this.props.setPreviousQuestion(step)}
                        goToRev={() => this.props.goToRev}
                        setRev={() => this.props.setRev()}
                        currentStep={this.props.currentStep}
                        hasError={this.state.currentAnswerError}
                        resetCurrentAnswerError={this.resetCurrentAnswerError}
                        previousQuestion={this.props.previousQuestion}
                    />
                )}

                {this.state.currentAnswerError && (
                    <div className="error">{item.RequiredErrorMessage}</div>
                )}
                {aboveCheckboxTextArr && (
                    <div
                        className="wizard-tool__legal-text u-margin-top-small"
                        onClick={(e) =>
                            this.openModal(
                                e,
                                item.TextWithPopups.TextWithPopupAboveCheckbox.PopUpText
                            )
                        }
                        dangerouslySetInnerHTML={{ __html: aboveCheckboxTextArr }}
                    />
                )}

                {item.Checkbox && (
                    <div className="wizard-tool__checkbox scform__checkbox scform__checkbox--single">
                        <label>
                            <input
                                type="checkbox"
                                name="cb"
                                id={"cb" + item.Id}
                                onChange={this.toggleCheckbox}
                                checked={this.state.checkboxChecked}
                                data-trackingid={this.props.data.Checkbox.CheckboxTrackingId}
                            />
                            <label
                                htmlFor={"cb" + item.Id}
                                onClick={(e) =>
                                    this.openModal(e, item.Checkbox.CheckboxPopupText)
                                }
                                dangerouslySetInnerHTML={{ __html: checkboxTextArr }}
                            />
                        </label>
                    </div>
                )}

                {this.state.checkboxCheckedError && (
                    <div className="error">{item.Checkbox.CheckboxValidationError}</div>
                )}

                {item.Buttons && (
                    <div className="wizard-tool__button">
                        {!item.Buttons.HideButtonsBelowQuestion && (
                            <div className="">
                                {item.Buttons.SecondaryButtonText && (
                                    <button
                                        type="button"
                                        id={item.Buttons.SecondaryButtonTrackingId}
                                        className="button u-margin-top-small button--hollow"
                                        disabled={
                                            this.state.isLoading || this.state.isLoadingSecondary
                                        }
                                        onClick={this.submitItemSecondary}
                                    >
                                        <span>{item.Buttons.SecondaryButtonText}</span>
                                        {this.state.isLoadingSecondary && (
                                            <svg
                                                focusable="false"
                                                aria-hidden="true"
                                                width="16"
                                                height="16"
                                                viewBox="0 0 16 16"
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        '<use xlink:href="/dist/svgsprite/icons.svg#Loading_16x16"/>',
                                                }}
                                            />
                                        )}
                                    </button>
                                )}

                                <button
                                    type="button"
                                    id={item.Buttons.NextButtonTrackingId}
                                    ref="submitBtn"
                                    className="button u-margin-top-small"
                                    disabled={
                                        this.state.isLoading || this.state.isLoadingSecondary
                                    }
                                    onClick={this.validateItem}
                                >
                                    <span>{item.Buttons.NextButtonText}</span>
                                    {this.state.isLoading && (
                                        <svg
                                            focusable="false"
                                            aria-hidden="true"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    '<use xlink:href="/dist/svgsprite/icons.svg#Loading_16x16"/>',
                                            }}
                                        />
                                    )}
                                    {!this.state.isLoading && (
                                        <svg
                                            focusable="false"
                                            aria-hidden="true"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                    '<use xlink:href="/dist/svgsprite/icons.svg#Arrow_No-stem_16x16"/>',
                                            }}
                                        />
                                    )}
                                </button>
                            </div>
                        )}
                    </div>
                )}

                {belowButtonTextArr && (
                    <div
                        className="wizard-tool__legal-text u-margin-top-small"
                        onClick={(e) =>
                            this.openModal(
                                e,
                                item.TextWithPopups.TextWithPopupBelowButtons.PopUpText
                            )
                        }
                        dangerouslySetInnerHTML={{ __html: belowButtonTextArr }}
                    />
                )}

                {showOverlaySpinner && (
                    <div className="overlay-spinner">
                        <svg
                            focusable="false"
                            aria-hidden="true"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            dangerouslySetInnerHTML={{
                                __html:
                                    '<use xlink:href="/dist/svgsprite/icons.svg#Loading_16x16"/>',
                            }}
                        />
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        quizSettings: quizSelector.quizSettings(state),
        previousQuestion: quizSelector.previousQuestion(state),
        currentStep: quizSelector.getCurrentStep(state),
        mapsAPIloaded: quizSelector.mapsAPIloaded(state),
        goToRev: quizSelector.goToRev(state),
    };
};

const mapDispatchToProps = {
    setQuizData,
    goToStep,
    setPreviousQuestion,
    setRev,
};

WizardToolQuestionWrapper = connect(
    mapStateToProps,
    mapDispatchToProps
)(WizardToolQuestionWrapper);
export default WizardToolQuestionWrapper;
